import FileUpload, { FileUploadProps } from './FileUpload';

/**
 * 일반 첨부 — 다중 업로드, 파일 형식 제한 없음, 500MB 제한.
 *
 * 호출자는 보통 onFilesAdded 콜백만 받아 실제 업로드 트리거. 라벨/안내문/허용 확장자는
 * 필요 시 props 로 override 가능.
 *
 * 다른 기능에서 "일반 첨부 UI" 가 필요하면 이 컴포넌트를 그대로 사용하면 됨 — 별도 분기 없음.
 */
export type FileAttachmentProps = Omit<FileUploadProps, 'variant'>;

const FileAttachment = (props: FileAttachmentProps) => (
  <FileUpload variant="default" {...props} />
);

export default FileAttachment;
